import {
  AddNewRoomListingSchemaType,
  Gender,
  ListingSchemaType,
} from "../api/schema";
export function mapListingToCreateForm(
  src: ListingSchemaType,
): AddNewRoomListingSchemaType {
  const demandLocations = (
    src as { demandLocations?: { code?: string | null }[] }
  ).demandLocations;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const srcAvailable = src.availableFrom ? new Date(src.availableFrom) : null;
  const availableFrom =
    srcAvailable && srcAvailable.getTime() >= today.getTime()
      ? srcAvailable
      : new Date();

  return {
    title: src.title ?? "",
    rentPrice: src.rentPrice ?? undefined,
    deposit: src.deposit ?? undefined,
    description: src.description ?? undefined,
    latitude: src.latitude ?? undefined,
    longitude: src.longitude ?? undefined,
    locationNormalizedName: src.locationNormalizedName ?? undefined,
    parishName: src.parishName ?? undefined,
    municipalityName: src.municipalityName ?? undefined,
    districtName: src.districtName ?? undefined,
    locationCodes: Array.isArray(demandLocations)
      ? demandLocations.map((d) => d.code).filter((c): c is string => !!c)
      : [],
    images: src.pictures ?? [],
    propertyType: src.propertyType ?? "room",
    businessType: src.businessType ?? "roomRent",
    gender: src.gender ?? Gender.ANY,
    maxPersons: src.maxPersons != null ? Number(src.maxPersons) : undefined,
    availableFrom,
    listingType: src.listingType,
    associatedUnitId: undefined,
    associatedUnitTitle: undefined,
    associatedPortfolioTitle: undefined,
  } as AddNewRoomListingSchemaType;
}
